// src/App.tsx
import React from 'react';
import { Box } from '@mui/material';
import SubdomainRouter from './components/routing/SubdomainRouter';

const App: React.FC = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
    <SubdomainRouter />
  </Box>
);

export default App;